export default {
    MWEB: 'mweb',
    DWEB: 'dweb',
};
